export const SITE_ORIGIN = 'https://bar-chess.sharkdevelop.com';
export const SOCIAL_IMAGE_PATH = '/social-background.webp';
export const SOCIAL_IMAGE_URL = `${SITE_ORIGIN}${SOCIAL_IMAGE_PATH}`;

export function clubSocialImageUrl(club) {
  return club?.socialPreviewUrl || undefined;
}
export const TOURNAMENT_SITEMAP_URL = 'https://admin.pdd-chess.sharkdevelop.com/api/public/sitemaps/tournaments.xml';
export const CLUB_SITEMAP_URL = 'https://admin.pdd-chess.sharkdevelop.com/api/public/sitemaps/clubs.xml';
export const SEASON_SITEMAP_URL = 'https://admin.pdd-chess.sharkdevelop.com/api/public/sitemaps/seasons.xml';
export const PUBLIC_PAGE_PATHS = ['/', '/features', '/pricing', '/about', '/clubs', '/changelog', '/chess/960'];

export function localeFromPath(path) {
  return /^\/ru(?:\/|$)/.test(path) ? 'ru' : 'en';
}

export function localizedPath(path, locale) {
  const stripped = path.replace(/^\/ru(?=\/|$|[?#])/, '') || '/';
  const unprefixed = /^[?#]/.test(stripped) ? `/${stripped}` : stripped;
  const normalized = publicPagePath(unprefixed);
  return locale === 'ru' ? `/ru${normalized}` : normalized;
}

// Только статические страницы используют каталоги на хостинге; адреса турниров не меняем.
export function publicPagePath(path) {
  const [, pathname, suffix] = path.match(/^([^?#]*)(.*)$/);
  const bare = pathname.replace(/\/+$/, '') || '/';
  return PUBLIC_PAGE_PATHS.includes(bare)
    ? `${bare === '/' ? '/' : `${bare}/`}${suffix}` : path;
}

export function documentationLink(path) {
  const [, pathname, suffix] = path.match(/^([^?#]*)(.*)$/);
  if (!pathname || /^(?:[a-z]+:|\/\/)/i.test(pathname) || /\.[^/]+$/.test(pathname)) return path;
  return `${pathname.replace(/\/$/, '')}/${suffix}`;
}
